import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { PodcastSolidGlyph, UserSolidGlyph } from '@acast-tech/decibel-glyphs';
import T from 'prop-types';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { black32, white } from '../../styles/colors';
import { Icon } from '../Icon/Icon';
import { Image } from '../Image/Image';
import { jsx as _jsx } from "react/jsx-runtime";
export const SIZES = {
  xxlarge: '128px',
  xlarge: '96px',
  large: '56px',
  medium: '40px',
  small: '32px',
  xsmall: '24px'
};
const LETTER_SIZES = {
  xxlarge: '80px',
  xlarge: '60px',
  large: '32px',
  medium: '24px',
  small: '16px',
  xsmall: '12px'
};
const SQUARE_BORDER_RADIUS = {
  xxlarge: '12px',
  xlarge: '8px',
  large: '4px',
  medium: '4px',
  small: '4px',
  xsmall: '2px'
};

const getIconGlyph = (defaultGlyph, variant) => {
  if (defaultGlyph) {
    return defaultGlyph;
  }

  return variant === 'user' ? UserSolidGlyph : PodcastSolidGlyph;
};

const Container = /*#__PURE__*/styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-1agsgft-0"
})(["display:flex;justify-content:center;align-items:center;flex-shrink:0;box-sizing:border-box;width:", ";height:", ";border-radius:", ";background:", ";color:", ";overflow:hidden;font-size:", ";"], props => SIZES[props.size], props => SIZES[props.size], props => props.variant === 'user' ? '100%' : SQUARE_BORDER_RADIUS[props.size], black32, white, props => LETTER_SIZES[props.size]);
const Letter = /*#__PURE__*/styled.span.withConfig({
  displayName: "Letter",
  componentId: "sc-1agsgft-1"
})(["font-size:inherit;font-weight:600;line-height:1em;text-transform:uppercase;white-space:nowrap;color:white;user-select:none;"]);
const Avatar = /*#__PURE__*/forwardRef(function Avatar(_ref, forwardedRef) {
  let {
    src,
    variant = 'user',
    size = 'small',
    glyph,
    initials,
    alt = ''
  } = _ref,
      restProps = _objectWithoutPropertiesLoose(_ref, ["src", "variant", "size", "glyph", "initials", "alt"]);

  let child;

  if (src) {
    child = /*#__PURE__*/_jsx(Image, {
      src: src,
      alt: alt,
      height: SIZES[size],
      placeholderGlyph: getIconGlyph(glyph, variant),
      placeholderGlyphColor: white,
      placeholderGlyphSize: size
    });
  } else if (initials) {
    child = /*#__PURE__*/_jsx(Letter, {
      children: initials
    });
  } else {
    child = /*#__PURE__*/_jsx(Icon, {
      glyph: getIconGlyph(glyph, variant),
      size: size
    });
  }

  return /*#__PURE__*/_jsx(Container, Object.assign({}, restProps, {
    ref: forwardedRef,
    variant: variant,
    size: size,
    children: child
  }));
});
Avatar.propTypes = {
  alt: T.string,
  title: T.string,
  src: T.string,
  variant: T.oneOf(['user', 'resource']),
  size: T.oneOf(Object.keys(SIZES)),
  glyph: T.elementType,
  initials: T.string
};
export { Avatar };